class ImageGenerator {
  constructor(el) {
    this.el = el;
    this.generatedImage = '';
    this.filename = '';
    this.previewTarget = this.el.getAttribute('data-js-preview-target');
    this.finalTarget = this.el.getAttribute('data-js-final-target');
    this.form = this.getParent(this.el, 'wpcf7-form');
    this.container = this.getParent(this.el, 'wpcf7');
    this.isImageGenerator = !!this.form.querySelector(
      '[name="image-generator"]',
    );
    this.imageUpload = this.form.querySelector('#asset-generator-image-upload');
    this.imageUploadPreview = this.form.querySelector(
      '#asset-generator-image-upload-preview',
    );
    this.downloadButton = this.form.querySelector('[data-js-imagedownload]');
    this.facebookShare = this.form.querySelector('[data-js-imagefb]');
    this.twitterShare = this.form.querySelector('[data-js-imagetwitter]');
    this.linkedInShare = this.form.querySelector('[data-js-imagelinkedin]');
    this.results = this.form.querySelector('#share-your-certificate');
    this.el.addEventListener('click', () => {
      this.getPreview();
    });
    this.container.addEventListener('wpcf7submit', (e) =>
      this.handleSuccess(e),
    );
    if (this.imageUpload) {
      this.imageUpload.addEventListener('change', () => this.previewUpload());
    }
  }

  previewUpload() {
    if (!this.imageUploadPreview) return;
    if (!this.imageUpload.files || !this.imageUpload.files[0]) return;

    const reader = new FileReader();

    reader.onload = (e) => {
      this.imageUploadPreview.src = e.target.result;
    };

    reader.readAsDataURL(this.imageUpload.files[0]);
  }

  getPreview() {
    $('.certificate-image-error-message').html('');
    $('.certificate-image-error-message').hide();
    $('.donation-spinner').show();

    const XHR = new XMLHttpRequest();
    const imageEls = this.form.querySelectorAll(this.previewTarget);
    const filenameEl = this.form.querySelector('[name="image-filename"]');
    const formData = new FormData(this.form);
    const generator = this;

    if (!imageEls.length > 0) {
      console.error('No target found');
      return;
    }

    imageEls.forEach((imageEl) => {
      imageEl.classList.add('u-none');
      imageEl.src = '';
    });

    XHR.addEventListener('load', function () {
      let response = {};
      let hasParseError = false;
      let hasServerError = false;
      try {
        response = JSON.parse(this.responseText);
      } catch {
        hasParseError = true;
      }

      if (this.status !== 200) {
        hasServerError = true;
      }

      if (hasServerError || hasParseError) {
        const errorMessage =
          response.message ||
          'Oops! Something went wrong. Please try again later.';
        $('.certificate-image-error-message').html(errorMessage);
        $('.certificate-image-error-message').show();
        $('.donation-spinner').hide();
      } else {
        generator.generatedImage = response.url;
        imageEls.forEach((imageEl) => {
          imageEl.classList.remove('u-none');
          imageEl.src = generator.generatedImage;
        });
        generator.downloadButton.href = generator.generatedImage;
        generator.facebookShare.href = generator.generateFBUrl();
        generator.twitterShare.href = generator.generateTwitterUrl();
        generator.linkedInShare.href = generator.generateLinkedInUrl();

        if (filenameEl) {
          generator.filename = response.filename;
          filenameEl.value = generator.filename;
        }
      }
    });

    XHR.addEventListener('error', () => {
      alert('Oops! Something went wrong. Please try again later.');
    });

    const url = this.isImageGenerator
      ? `${guidedogsGlobals.gdresturl}image-generator`
      : `${guidedogsGlobals.gdresturl}grad-day`;

    XHR.open('POST', url);
    XHR.send(formData);
  }

  handleSuccess() {
    this.results.classList.add('is-visible');
  }

  getParent(el, className) {
    let isParent = false;
    let count = 0;
    let currentEl = el;

    while (!isParent && count < 20) {
      if (currentEl.parentElement.classList.contains(className)) {
        isParent = true;
      }
      currentEl = currentEl.parentElement;
      count += 1;
    }

    return isParent ? currentEl : null;
  }

  generateFBUrl() {
    return `https://www.facebook.com/sharer/sharer.php?u=${this.generatedImage}`;
  }

  generateTwitterUrl() {
    return `https://twitter.com/intent/tweet?text=Graduation%20class%20of%202023&url=${this.generatedImage}&hashtags=GuideDogsAustralia`;
  }

  generateLinkedInUrl() {
    return `https://www.linkedin.com/shareArticle?mini=true&text=Graduation%20class%20of%202023&url=${this.generatedImage}`;
  }
}

export function init() {
  const imageGenerators = document.querySelectorAll('[data-js-generate-image]');

  if (imageGenerators.length > 0) {
    imageGenerators.forEach((imageGenerator) => {
      new ImageGenerator(imageGenerator);
    });
  }
}
